import React, { useState, useEffect } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { Box, CircularProgress, List, ListItem, Typography, Button, TextField, DialogContent, Dialog } from '@material-ui/core'
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import { useHistory, useLocation } from 'react-router-dom';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import { Add, Clear, Close, DeleteOutline } from '@material-ui/icons'
import icBlueAdd from '../assets/icons/icBlueAdd.png'
import icTv from '../assets/icons/Generate-tv-channel.png'
import icPen from '../assets/icons/pen.png'
import icDelete from '../assets/icons/Trash-black.png'
import { Link } from "react-router-dom";
import Snackbar from '../common/snackbar';
import icArrowUp from '../assets/icons/white-arrow-up.png';
import icArrowDown from '../assets/icons/white-arrow-down.png';
import Checkbox from '../checkbox'
import Search from '../search'
import { StyledButton } from '../common/table/index'
const useStyles = makeStyles(theme => ({
    tableSortLabel: {
        color: 'theme.palette.common.white',
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    },
    textEdit: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    dialogContent: {
        padding: '20px 8px !important'
    },
    icons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 7,
        cursor: 'pointer'
    },
    icon: {
        width: 9,
        height: 9
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}));

const Firmwares = () => {
    const dataProvider = useDataProvider()
    const classes = useStyles()
    const translate = useTranslate()
    const [data, setData] = useState([])
    const [click, SetClick] = useState({ firmware: false, model: false, version: false })
    const { permissions, loaded } = usePermissions();
    const [openConfirmDialog, setOpenConfirmDialog] = useState({
        status: false,
        index: -1
    })
    const [loading, setLoading] = useState(false)
    const [showSnackbar, setShowSnackbar] = useState(false)
    const [showMessagePopup, setMessagePopup] = useState(false)
    const [showSnackbarEdit, setShowSnackbarEdit] = useState({
        name: '',
        message: '',
        status: false
    })
    const [filter, setFilter] = useState('')
    const [dataFilter, setDataFilter] = useState([])
    const [messagePopupContent, setMessagePopupContent] = useState('')
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme()

    const getList = () => {
        setLoading(true)
        dataProvider('GET_LIST', "firmware", {
            filter: {
            },
            pagination: {
                page: -1,
                perPage: 0
            },
            sort: { field: 'createdAt', order: 'ASC' },

        })
            .then(({ data }) => {
                if (data) {
                    setData(data);
                    setDataFilter(data)
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }

    React.useEffect(() => {
        getList()
        if (location.state && location.state.open) {
            setShowSnackbar(true);
            setTimeout(() => {
                setShowSnackbar(false);
            }, 6000);
        }
    }, [])

    const onCancel = (index) => {
        let temps = data.slice()
        temps[index].edit = false
        delete temps[index].editName
        setData(temps)
    }

    const onClick = (prop) => {
        let temps = [...dataFilter]
        temps.sort((a, b) => {
            var x, y
            if (prop === 'version') {
                x = a.version.toLowerCase();
                y = b.version.toLowerCase();
            } else {
                x = a[prop].name.toLowerCase();
                y = b[prop].name.toLowerCase();
            }

            if (x < y) { return click[prop] ? -1 : 1; }
            if (x > y) { return click[prop] ? 1 : -1; }
            return 0
        })
        setDataFilter(temps)
        SetClick({ ...click, [prop]: !click[prop] })
    }

    const handleOnDelete = () => {
        if (openConfirmDialog.index > -1) {
            dataProvider('DELETE', " firmware", {
                id: data[openConfirmDialog.index].id
            })
                .then(() => {
                    getList()
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
                .catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
        }
        else {
            var requests = []
            dataFilter.forEach(element => {
                element.checked && requests.push(
                    dataProvider('DELETE', "firmware", {
                        id: element.id
                    })
                )
            })
            if (requests.length > 0) {
                Promise.all(requests).then(() => {
                    getList()
                    setOpenConfirmDialog({ status: false, index: -1 })
                }).catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                });
            }
            else
                setOpenConfirmDialog({ status: false, index: -1 })

        }

    }


    const handleCheckMark = (event, index, checkAll) => {
        let temps = dataFilter.slice()
        if (!checkAll)
            temps[index].checked = event.target.checked
        else
            temps.map(item => {
                item.checked = event.target.checked
                return item
            })
        setDataFilter(temps)
    }


    const onClear = () => {
        let temps = dataFilter.slice()
        temps.map(item => {
            delete item.checked
            return item
        })
        setDataFilter(temps)
    }


    const submitFilter = () => {
        setDataFilter(data.filter(item => item.firmware.name.toUpperCase().includes(filter.toUpperCase())
            || item.model.name.toString().toUpperCase().includes(filter.toUpperCase())
            || item.version.toString().toUpperCase().includes(filter.toUpperCase())
        ))
    }


    if (loading || !loaded) return <Loading />
    return (
        <Box width='100%' display='flex' justifyContent='center'>
            <Box width='60%' mt={8}>
                <Box width='100%' display='flex' justifyContent='flex-end' mt={2}>
                    {location.state &&
                        <Snackbar
                            show={showSnackbar}
                            boldText={location.state && location.state.name}
                            message={location.state && location.state.message}
                            onClose={() => setShowSnackbar(false)}
                        />
                    }
                </Box>
                <Box width='100%' display='flex' alignItems='center'>
                    <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center" >
                        <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', lineHeight: '21.6px', color: '#4f5064', fontWeight: 500 }}>{translate(`pos.devices.deviceFirmware`)}</Typography>
                        {
                            dataFilter.length > 0 ? <Typography className={classes.subText}>({dataFilter.length})</Typography>
                                : <Typography className={classes.subText}>(0)</Typography>
                        }
                    </Box>
                    <Search
                        placeholder={translate(`pos.devices.deviceFirmware`)}
                        onChangeText={setFilter}
                        getList={submitFilter}
                    />
                    {
                        permissions.functionAction.find(value => value.function === 'Remote FirmWare' && value.isUpdate) &&
                        <Box ml={4}>
                            <Button variant='contained' color='primary'
                                component={Link}
                                to={{
                                    pathname: "/DeviceFirmware/create"
                                }}
                            >
                                <Typography style={{ fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', fontFamily: 'UniviaPro-Bold' }}>{translate(`pos.devices.createNewDeviceFirmware`)}</Typography>

                                <Add />
                            </Button>

                        </Box>
                    }

                </Box>
                <Box>
                    <Box display='flex' px={3} py={1} mt={1} bgcolor={dataFilter.filter(item => item.checked).length > 0 ? '#56657f' : theme.palette.primary.main}>
                        <Box flexGrow={1} display='flex' alignItems='center'>
                            <Box minWidth={dataFilter.filter(item => item.checked).length > 0 ? 20 : 100}>
                                <Checkbox checked={dataFilter.length > 0 && dataFilter.length === dataFilter.filter(item => item.checked).length ? true : false} onChange={(event) => handleCheckMark(event, -1, true)}></Checkbox>
                            </Box>
                            {
                                dataFilter.filter(item => item.checked).length > 0 ?
                                    <Box display='flex' justifyContent='space-between' width='100%' style={{ pointerEvents: permissions.functionAction.find(value => value.function === 'Remote FirmWare' && value.isUpdate) ? 'auto' : 'none' }}>
                                        <StyledButton
                                            onClick={() => {
                                                setOpenConfirmDialog({
                                                    status: true,
                                                    index: -1
                                                })
                                            }}
                                            variant='text'
                                            startIcon={<DeleteOutline />}
                                        >
                                            {translate(`pos.common.delete`)}
                                        </StyledButton>
                                        <StyledButton
                                            onClick={onClear}
                                            variant='text'
                                            startIcon={<Clear />}
                                        >{dataFilter.filter(item => item.checked).length} {dataFilter.filter(item => item.checked).length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                                    </Box>
                                    :
                                    <Box width='100%' display='flex'>
                                        <Box display='flex' width={250}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                {translate(`pos.devices.devicePlatform`)}
                                            </Typography>
                                            <div className={classes.icons}>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={() => onClick('firmware')} style={{ opacity: click.firmware === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.firmware === false ? 0 : 1 }} onClick={() => onClick('firmware')} />
                                            </div>
                                        </Box>
                                        <Box display='flex' width={250}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                {translate(`pos.devices.deviceModel`)}
                                            </Typography>
                                            <div className={classes.icons}>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={() => onClick('model')} style={{ opacity: click.model === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.model === false ? 0 : 1 }} onClick={() => onClick('model')} />
                                            </div>
                                        </Box>
                                        <Box display='flex' width={200}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                {translate(`pos.deviceFirmware.firmware`)}
                                            </Typography>
                                            <div className={classes.icons}>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={() => onClick('version')} style={{ opacity: click.version === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.version === false ? 0 : 1 }} onClick={() => onClick('version')} />
                                            </div>
                                        </Box>

                                    </Box>
                            }

                        </Box>
                    </Box>
                    <Box height='60vh' style={{ overflow: 'auto' }}>
                        {
                            dataFilter.map((item, index) => (
                                item && <Box key={'channel' + index} display='flex' px={3} py={2} mt={1} bgcolor='white' style={{ pointerEvents: permissions.functionAction.find(value => value.function === 'Remote FirmWare' && value.isUpdate) ? 'auto' : 'none' }}>
                                    <Box flexGrow={1} display='flex' alignItems='center'>
                                        <Box display='flex' width={100} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                                            <Checkbox color='primary' checked={item.checked ? true : false} onChange={(event) => handleCheckMark(event, index, false)}></Checkbox>
                                        </Box>
                                        <Box display='flex' width={250} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis' >
                                            <Typography onClick={() => {
                                                history.push('/DeviceFirmware/' + item.id)

                                            }} style={{ cursor: 'pointer', letterSpacing: 'normal', color: 'green', fontFamily: 'UniviaPro-Medium', fontWeight: 500 }} >{item.firmware ? item.firmware.name : ''}</Typography>
                                        </Box>

                                        <Box display='flex' width={250} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis' >
                                            <Typography
                                                style={{ textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Medium', fontWeight: 500 }}
                                                variant='body1'>
                                                {item.model.name}
                                            </Typography>
                                        </Box>

                                        <Box display='flex' style={{ cursor: 'pointer' }} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis' onClick={() => {
                                            history.push({
                                                pathname: '/ClientDevice',
                                                state: item.version
                                            })
                                        }}>
                                            <Typography

                                                style={{ cursor: 'pointer', textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Medium', fontWeight: 500 }}
                                                variant='body1' color='primary'>
                                                {item.version}
                                            </Typography>
                                        </Box>


                                    </Box>


                                </Box>
                            ))
                        }
                    </Box>
                </Box>
            </Box>
            <ConfirmDialog
                open={openConfirmDialog.status}
                handleClose={() => { setOpenConfirmDialog({ status: false, index: -1 }) }}
                handleConfirm={handleOnDelete}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={translate('pos.deviceFirmware.delete')} />
            {/* 
            <Dialog open={showMessagePopup} scroll='paper'>
                <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                    <IconRadiusButton onClick={onCloseMessagePopup}>
                        <Close color='primary' />
                    </IconRadiusButton>
                </Box>
                <DialogContent>
                    <Box mx={2.5} className={classes.dialogContent}>
                        {messagePopupContent}
                    </Box>
                </DialogContent>
            </Dialog> */}
        </Box>
    )
}
export default Firmwares